import React from "react";
import { BASE_URL } from "../api";

const pageUrl = document.getElementById("bluebook-root")?.dataset.page;

const Button = () => {
  const handleClick = () => {
    //@ts-ignore
    window.location = `${BASE_URL}/${pageUrl}`;
  };

  return (
    <div style={{ textAlign: "left", marginTop: "30px" }}>
      <button className="bluebook-btn" onClick={handleClick}>
        GET AN INSURANCE QUOTE
      </button>
    </div>
  );
};

export default Button;
